/** Poll only while focused (caller owns disposal) and visible; serialize slow refreshes. */
export function foregroundPoll(
  refresh: () => Promise<void>,
  isVisible: () => boolean,
  subscribe: (cb: (visible: boolean) => void) => () => void,
  interval = 30_000,
): () => void {
  let stopped = false, running = false;
  let timer: ReturnType<typeof setTimeout> | undefined;
  const clear = () => { clearTimeout(timer); timer = undefined; };
  const run = async () => {
    clear();
    if (stopped || running || !isVisible()) return;
    running = true;
    try { await refresh(); } catch { /* Next foreground refresh retries. */ }
    finally {
      running = false;
      if (!stopped && isVisible()) timer = setTimeout(() => { run().catch(() => {}); }, interval);
    }
  };
  const unsubscribe = subscribe(visible => { clear(); if (visible) run().catch(() => {}); });
  run().catch(() => {});
  return () => { stopped = true; clear(); unsubscribe(); };
}
